import React from 'react';
import { Container, Typography } from '@mui/material';
import BonusCatalogCard from '../components/settings/BonusCatalogCard';

/** Organization > Bonus Categories. A super user creates the categories; supervisors pick from this list in the Bonus Tracker. */
const BonusCategoriesPage: React.FC = () => (
  <Container maxWidth="lg" sx={{ mt: 3, mb: 4 }}>
    <Typography variant="h4" gutterBottom>Bonus Categories</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      The list of bonuses that supervisors can pick from when they add a bonus. Only a super user creates or changes a category.
    </Typography>
    <BonusCatalogCard />
  </Container>
);

export default BonusCategoriesPage;
